import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Aichat from '@/api/aichat/index';

var moment = require('moment');

export default {
  name: 'AiChat',
  data: function data() {
    return {
      showChat: false,
      userInput: '',
      selectedBot: '1',
      // 默认选择 Bot1
      messages: {
        1: [],
        2: []
      },
      userName: ''
    };
  },
  watch: {
    showChat: function showChat(newVal) {
      var _this = this;

      if (newVal) {
        this.$nextTick(function () {
          _this.scrollToBottom();
        });
      }
    },
    selectedBot: function selectedBot(newVal) {
      var _this2 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          _this2.scrollToBottom();
        }, 100);
      });
    }
  },
  mounted: function mounted() {
    this.userName = this.$store.state.user.user.userName;
    this.loadMessages();
  },
  methods: {
    moment: moment,
    loadMessages: function loadMessages() {
      var storedMessages = localStorage.getItem(this.userName + '_chatMessages');

      if (storedMessages) {
        this.messages = JSON.parse(storedMessages);
      }
    },
    saveMessages: function saveMessages() {
      localStorage.setItem(this.userName + '_chatMessages', JSON.stringify(this.messages));
    },
    toggleChat: function toggleChat() {
      this.showChat = !this.showChat;
    },
    handleEnter: function handleEnter(event) {
      if (!event.shiftKey) {
        // 只有按 Enter 时才发送消息，Shift+Enter 允许换行
        event.preventDefault();
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      var _this3 = this;

      if (!this.userInput.trim()) return;
      var botType = 1;
      var userMessage = {
        role: 'user',
        content: this.userInput,
        time: this.formatTime()
      };
      this.messages[botType].push(userMessage);
      this.userInput = '';
      this.saveMessages();
      this.$nextTick(function () {
        _this3.scrollToBottom(); // 发送后滚动到底部

      });

      try {
        var params = {
          bot_type: botType,
          messages: userMessage.content
        };
        Aichat.sendMessage(params).then(function (res) {
          var fullText = res.rtn_data.message.replace(/\n/g, '<br>');
          var aiMessage = {
            role: 'ai',
            content: fullText,
            time: _this3.formatTime()
          };

          _this3.messages[botType].push(aiMessage);

          _this3.saveMessages();

          _this3.$nextTick(function () {
            _this3.scrollToBottom(); // 让滚动条跟随

          });
        });
      } catch (error) {
        console.error('AI 响应错误', error);
      }
    },
    sendCentreMessage: function sendCentreMessage() {
      var _this4 = this;

      if (!this.userInput.trim()) return;
      var botType = 2;
      var userMessage = {
        role: 'user',
        content: this.userInput,
        time: this.formatTime()
      };
      this.messages[botType].push(userMessage);
      this.userInput = '';
      this.saveMessages();
      this.$nextTick(function () {
        _this4.scrollToBottom(); // 发送后滚动到底部

      });

      try {
        var params = {
          bot_type: botType,
          messages: userMessage.content
        };
        Aichat.sendMessage(params).then(function (res) {
          var fullText = res.rtn_data.message.replace(/\n/g, '<br>');
          var aiMessage = {
            role: 'ai',
            content: fullText,
            time: _this4.formatTime()
          };

          _this4.messages[botType].push(aiMessage);

          _this4.saveMessages();

          _this4.$nextTick(function () {
            _this4.scrollToBottom(); // 让滚动条跟随

          });
        });
      } catch (error) {
        console.error('AI 响应错误', error);
      }
    },
    formatTime: function formatTime() {
      var now = new Date();
      return now.toLocaleString();
    },
    scrollToBottom: function scrollToBottom() {
      var _this5 = this;

      this.$nextTick(function () {
        var chatBody = _this5.$el.querySelector('.chat-body');

        if (chatBody) {
          chatBody.scrollTop = chatBody.scrollHeight;
        }
      });
    }
  }
};